export const APP_VERSION = 'v1';
